module.exports = __webpack_public_path__ + "img/logo1.ef1174b9.svg";